<template>
    <div class="animated fadeIn">        
        <b-card>
            <div slot="header">
                Inventory Trnasfer Out Form
                <div class="card-header-actions">
                <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
              <b-row>
                <b-col lg="8">
                    <b-row>
                        <b-col lg="6">
                            <b-input-group >
                                <b-input-group-prepend><label style="width:160px;">From Store/Warehouse</label></b-input-group-prepend>
                                <b-form-select v-model="model.idStore" :plain="true" :options="Warehouse" :state="!$v.model.idStore.$error"></b-form-select>
                            </b-input-group>
                        </b-col>
                        <b-col lg="6">
                            <b-input-group >
                                <b-input-group-prepend><label style="width:160px;">To Store/Warehouse</label></b-input-group-prepend>
                                <b-form-select v-model="model.toStore" :plain="true" :options="toWarehouse" :state="!$v.model.toStore.$error" ></b-form-select>
                            </b-input-group>
                        </b-col>
                    </b-row>    
                    <b-row>
                        <b-col lg="6">
                        <b-input-group>
                            <b-input-group-prepend><label>Transfer Doc. Number</label></b-input-group-prepend>
                            <b-form-input v-model="model.nomor" readonly></b-form-input>
                        </b-input-group>
                        </b-col>
                        <b-col lg="6">                            
                        <b-input-group>
                            <b-input-group-prepend><label style="width:160px;">Transfer Date</label></b-input-group-prepend>
                            <b-form-input v-model="model.tanggal" type="date" @change="tanggalBerubah" :max="maxTrfDate" :state="!$v.model.tanggal.$error"></b-form-input>                                        
                        </b-input-group>
                        </b-col>
                    </b-row>    
                    <b-row>
                        <b-col lg="6">
                        <b-input-group>
                            <b-input-group-prepend><label>Received By</label></b-input-group-prepend>
                            <b-form-input v-model="model.receivby" readonly></b-form-input>
                        </b-input-group>
                        </b-col>
                        <b-col lg="6">                            
                        <b-input-group>
                            <b-input-group-prepend><label style="width:160px;">Received Date</label></b-input-group-prepend>
                            <b-form-input v-model="model.recivDate" type="date" readonly></b-form-input>                                        
                        </b-input-group>
                        </b-col>
                    </b-row> 
                    <b-input-group >
                        <b-input-group-prepend><label>Note/Remark</label></b-input-group-prepend>
                        <b-form-textarea
                        id="textarea"
                        v-model="model.uraian"
                        :state="!$v.model.uraian.$error"
                        placeholder="Enter uraian"
                        rows="3"
                        max-rows="6"
                        ></b-form-textarea>
                    </b-input-group>
                    
                    <!-- <b-input-group >
                        <b-input-group-prepend><label>Received By</label></b-input-group-prepend>
                        <b-form-input v-model="model.receivedby" :state="!$v.model.receivedby.$error"></b-form-input>                                        
                    </b-input-group> -->
                </b-col>
                <b-col md="4">
                    <v-dim :model="model" :key="updateDimHdr" ></v-dim>
                </b-col>
              </b-row>
              <b-card no-body class="mb-1">
                <b-table
                    class="mb-0"
                    ref="tblIssuedLines"
                    outlined
                    striped hover small
                    style="font-size:smaller;"
                    :items="issuedLines.items"
                    :fields="issuedLines.fields"
                    :current-page="issuedLines.page"
                    :per-page="issuedLines.limit"
                    >
                        <template v-slot:cell(index)="data">
                        {{data.index + 1}}
                        </template>
                        <template v-slot:cell(partnumber)="data">
                            {{data.item.partnumber}} | {{data.item.itemname}}
                        </template>
                        <template v-slot:cell(quantity)="data">
                            {{data.item.qtyTrfOut}} {{data.item.unitsize}}
                        </template>
                        <template v-slot:cell(unitprice)="data">
                        {{data.item.nilai|numFormat}}
                        </template>
                        <template v-slot:cell(action)="data">
                            <div class="text-center">
                            <a href="javascript:void(0)" @click="editIssuedLines(data.item,data.toggleDetails)">
                                <i class="fa fa-pencil"></i>
                            </a>
                            |
                            <a href="javascript:void(0)" class="text-danger" @click="delIssuedLines(data.index)">
                                <i class="fa fa-trash"></i>
                            </a>
                            </div>
                        </template>
                    <template v-slot:row-details="row">
                    <b-card class="row-details-form">
                      <b-row  align-h="center">
                        <b-col lg="6" xl="6" class="pl-0">
                                <b-input-group>
                                    <b-input-group-prepend><label>Item Inventory</label></b-input-group-prepend>
                                    <b-form-input readonly v-model="issuedLinesObj.iteminfo" @keyup.13.native="lkuItemShow=true" :state="!$v.issuedLinesObj.itemno.$error"></b-form-input>
                                    <b-input-group-append>
                                    <b-btn text="Button" @click="lkuItemShow=true">
                                        <i class="fa fa-search"></i>
                                    </b-btn>
                                    </b-input-group-append>
                                </b-input-group>
                            <b-form-row>
                              <b-col md="7">                            
                                <b-input-group>
                                    <b-input-group-prepend><label>Model/Type/Series</label></b-input-group-prepend>
                                    <b-form-input readonly v-model="issuedLinesObj.typeseries" ></b-form-input>
                                </b-input-group>
                              </b-col>
                              <b-col md="5">                            
                                <b-input-group>
                                    <b-input-group-prepend><label style="width:70px; text-align:right;">Receiv Date</label></b-input-group-prepend>
                                    <b-form-input readonly v-model="issuedLinesObj.recivDate" ></b-form-input>
                                </b-input-group>
                              </b-col>
                            </b-form-row >   
                            <b-form-row>
                              <b-col md="7">                            
                                <b-input-group>
                                    <b-input-group-prepend><label>Serial Number</label></b-input-group-prepend>
                                    <b-form-input readonly v-model="issuedLinesObj.serialNum"  ></b-form-input>
                                </b-input-group>
                              </b-col>
                              <b-col md="5">                            
                                <b-input-group>
                                    <b-input-group-prepend><label style="width:70px; text-align:right;">Expired Date</label></b-input-group-prepend>
                                    <b-form-input readonly v-model="issuedLinesObj.expirDate" ></b-form-input>
                                </b-input-group>
                              </b-col>
                            </b-form-row >   
                            <b-form-row v-show="(issuedLinesObj.qtyUndefined==0)">
                              <b-col md="6">                            
                                <b-input-group>
                                    <b-input-group-prepend><label>Quantity Available</label></b-input-group-prepend>
                                    <b-form-input v-model="issuedLinesObj.qtyAvail" type="number" readonly></b-form-input>
                                    <b-form-input v-model="issuedLinesObj.unitsize" readonly></b-form-input>
                                </b-input-group>
                              </b-col>
                              <b-col md="6">                            
                                <b-input-group>
                                    <b-input-group-prepend><label>Quantity Transfer</label></b-input-group-prepend>
                                    <b-form-input v-model="issuedLinesObj.qtyTrfOut" type="number" ></b-form-input>
                                    <b-form-input v-model="issuedLinesObj.unitsize" readonly></b-form-input>
                                </b-input-group>
                              </b-col>
                            </b-form-row >   
                            <b-input-group v-show="(issuedLinesObj.qtyUndefined==1)">
                                <b-input-group-prepend><label>Issued Note</label></b-input-group-prepend>
                                <b-form-input v-model="issuedLinesObj.uraian" ></b-form-input>
                            </b-input-group>

                            <b-form-row>
                              <b-col md="6">                            
                                <b-input-group>
                                    <b-input-group-prepend><label style="width:70px; text-align:right;">Cost Price</label></b-input-group-prepend>
                                    <b-input-group-prepend>
                                        <span class="input-group-text" style="width:60px;">{{uanguser}}</span>
                                    </b-input-group-prepend>
                                    <my-number class="form-control text-right" v-model="issuedLinesObj.invUnitCost" :precision="2" :disabled="(issuedLinesObj.qtyUndefined==0)"></my-number>
                                </b-input-group>
                              </b-col>
                              <b-col md="6">                            
                                <b-input-group>
                                    <b-input-group-prepend><label style="width:70px; text-align:right;">Cost Amount</label></b-input-group-prepend>
                                    <b-input-group-prepend>
                                        <span class="input-group-text" style="width:60px;">{{uanguser}}</span>
                                    </b-input-group-prepend>
                                    <my-number class="form-control text-right" v-model="issuedLinesObj.nilai" :precision="2" disabled></my-number>
                                </b-input-group>
                              </b-col>

                            </b-form-row >   
                        </b-col>
                        <b-col lg="6" xl="5">
                            <v-dim :model="issuedLinesObj" :key="updateDimDtl" :horizontal="true"></v-dim>
                        </b-col>
                      </b-row>
                      <b-row class="justify-content-center mt-1">
                        <b-button v-if="saveEnabled" class="btn btn-success mr-1" @click.stop="saveIssuedLines()">Update</b-button>
                        <b-button class="btn btn-warning ml-1" @click.stop="row.toggleDetails">Cancel</b-button>
                      </b-row>
                    </b-card>
                    </template>                        
                </b-table>
                <b-form-row>
                    <b-col cols="6">
                        <b-row>
                        <b-button size="sm" class="ml-3" @click.stop="addIssuedLines" >Add Issued item</b-button>                          
                        <div class="ml-2">
                            Showing
                            {{(issuedLines.page - 1) * issuedLines.limit + 1}}
                            to
                            {{issuedLines.page * issuedLines.limit}}
                            <strong>
                            of
                            {{issuedLines.total}}
                            entries </strong>
                        </div>    
                        </b-row>                    
                    </b-col>
                    <b-col cols="6">
                    <b-pagination
                        align="right"
                        :total-rows="issuedLines.total"
                        :per-page="issuedLines.limit"
                        v-model="issuedLines.page"
                    ></b-pagination>
                    </b-col>
                </b-form-row>
              </b-card>    
            <b-row class="justify-content-center mb-2">
                <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                <button class="btn btn-primary" @click="close()" > <i class="fa fa-close"></i> Close</button>
            </b-row>

        </b-card>
        <!-- <b-modal v-model="lkuItemShow" size="lg" :hide-footer="true" title="List of Item Inventory" :key="model.idStore" :centered="true">
            <lku-item @click="onSelectLkuItem" :idStore="model.idStore"></lku-item>
        </b-modal>         -->
        <b-modal v-model="lkuItemShow" size="lg" :hide-footer="true" title="List of Available Inventory" :key="model.idStore" :centered="true">
            <lku-item @click="onSelectLkuItem" :idStore="model.idStore"></lku-item>
        </b-modal>        
        <b-modal v-model="lkuSalesShow" size="lg" :hide-footer="true" title="List of Sales Transaction" :centered="true">
            <h2>belum tersedia</h2>
        </b-modal>        
        <b-modal v-model="lkuMrShow" size="lg" :hide-footer="true" title="List of Material Requesition" :centered="true">
            <lku-mr @click="onSelectLkuMr"></lku-mr>
        </b-modal>        

    </div>
</template>
<style lang="scss">
    .report-wraper {
         width:100%;
         overflow-x: auto;
         overflow-y: auto;
        min-height: 100px;
        border: 1px solid silver;
        table {
            font-size: smaller;
            th {
                border: 1px solid silver;
                padding: 0 15px;
                height: 30px;
                background: #e8e8e8;
            }              
            tbody tr:hover {
                background-color: rgba(91,192,222, 0.2) !important;
                cursor: default;
            }

            td {
                border: 1px solid silver;
                padding: 0 10px;
                height: 25px;
            }
            
            td.tebal {
                font-weight: bold;
            }
            
            td.subtotal {
                border-top: 2px solid #000 !important;
            }
        }
    }
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 130px;
            }
        }
    }
    .form-group {
        margin-bottom:2px;
        .input-group {
            padding-bottom:0;
        }
    }
    .row-details-form {
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 80px;
            }
        }
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
    }
</style>

<script>
import toastr from "mini-toastr";
import moment from 'moment';
import myNumber from "../../components/my-number";
import vDim from "../lookup/dim";
// import lkuItem from "../lookup/lkuItem"; ini untuk metode EVERAGE
import lkuItem from "../lookup/lkuItemReceipt";
import lkuMr from "../lookup/lkuMr";
import inv from "../../apis/logistic_inv_out";
import mr from "../../apis/logistic_mr";
import procure from "../../apis/procure";
import dimension from "../../apis/dimension";
import invTrf from "../../apis/logistic_inv_trf";
import { validationMixin } from "vuelidate";
import { required, requiredUnless, requiredIf , numeric } from "vuelidate/lib/validators";
toastr.init();

export default {   
  components: { myNumber, vDim, lkuItem, lkuMr},
  mixins: [validationMixin],
  validations: {
        model: {
            idStore: { required },
            toStore: { required },
            tanggal: { required },
            uraian: { required },
        },
        issuedLinesObj: {
            itemno: { required },
            uraian: { required:requiredIf('qtyUndefined') },
            qtyTrfOut: { numeric, required:requiredUnless('qtyUndefined')  },
            nilai: { numeric, required }
        },
  }, 
  data() {
    return {
        saveEnabled:true,
        horizontal:true,
        lkuItemShow:false,
        lkuMrShow:false,
        lkuSalesShow:false,
        updateDimHdr:false,
        updateDimDtl:true,
        tahun:(this.$store.state.user.tglaktif || '').substring(0,4),
        uanguser: this.$store.state.user.matauang,
        currency:[{value:'IDR',text:'IDR'}],
        Warehouse : [],
        fromWarehouse:[],
        toWarehouse:[],
        model:{idStore:'', toStore:'', sales:0},
        issuedLines: {
            items: [],
            selected:{},
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "partnumber",
                    label: "Item Inventory",
                },
                {
                    key: "quantity",
                    label: "Quantity",
                    thStyle: "width:100px",
                    thClass: "text-center",
                    tdClass: "text-center"
                },
                {
                    key: "unitprice",
                    label: "Estimate Price",
                    thStyle: "width:110px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "action",
                    label: "Action",
                    thStyle: "width:40px",
                    thClass: "text-center",
                },
            ],
            page: 1,
            limit: 5,
            total: 0,
        },
        issuedLinesObj:{itemno:'', description:'', quantity:0, unitzise:'', qtyUndefined:0},
        listItemRequested : []
    };
},
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    invalidIssuedLines() {
    //   this.issuedLines.kenappn= (this.issuedLines.ppn != 0); 
      this.$v.issuedLinesObj.$touch();
      return this.$v.issuedLinesObj.$invalid;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    unitprice(){
        return this.issuedLinesObj.invUnitCost;
    },
    qtyUndefined(){
        if(this.issuedLinesObj.qtyUndefined==1){
            return true;
        }else{
            return false;
        }
    },
    ifSales(){
        if(this.model.sales == 1){
            return true;
        }else{
            return false;
        }
    },
    toWarehouse_(){
        return this.model.idStore
    },
    maxTrfDate(){
        return moment(new Date()).format('YYYY-MM-DD');
    }
  },
  watch: {
    unitprice: function(newval) {
        setTimeout(() => {
            this.calcAmount();
        }, 100);
    },    
    toWarehouse_:function(newval){
        this.toWarehouse = this.Warehouse.filter(x=> x.value != newval)
    }
    
  },
  created: async function(){
    //   this.currency = await procure.currency();
      this.Warehouse = await inv.store(); 

    if (this.$route.params.invTrfKey)  {
          toastr.info('Loading Request Detail, please wait')
          try {
            const data = await invTrf.detail(this.$route.params);  
            const row = data[0][0];
            // this.saveEnabled=(row.send2wf === 0);
            row.tanggal = row.tanggal ? moment(row.tanggal).format('YYYY-MM-DD') : '';
            row.expectreceipt = row.expectreceipt ? moment(row.expectreceipt).format('YYYY-MM-DD') : '';
            row.receivedby = row.invTrfReceivby || null;
            for (var key in row) {
                this.model[key] = row[key];
            }
            this.model.receivedby = row.invTrfReceivby || null;
            data[1].forEach((el,idx)=>{
                data[1][idx].quantity = el.qtyTrfOut;
                data[1][idx].unitsize = el.invunitom;
                data[1][idx].nilai = el.issueValue;
            })
            this.issuedLines.items = data[1];
            this.issuedLines.total=this.issuedLines.items.length;
            this.model.terms = data[2];
            this.calcTotalDtlIssued();
            this.tanggalBerubah();
            this.updateDimHdr = !this.updateDimHdr;
            this.$forceUpdate();                
            toastr.clear;
          } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
      } 
  },
  methods: {
    closeIssuedLines: function(){
        const opened= this.issuedLines.items.find( r=> r._showDetails==true);
        if (opened) opened._showDetails=false;
    },
    addIssuedLines : function () {
        this.closeIssuedLines();
        const obj={_showDetails:true};
        this.issuedLines.selected = obj;
        for (var key in this.issuedLinesObj) {
            this.issuedLinesObj[key] = '';
        }
        this.issuedLinesObj.unitsize='EACH';
        this.issuedLinesObj.qtyTrfOut = 1;
        this.issuedLinesObj.qtyUndefined = 0;
        this.updateDimHdr2Dtl(this.issuedLinesObj);
        this.issuedLines.items.push(obj);
        this.issuedLines.total=this.issuedLines.items.length;
        setTimeout(() => {
                const bfore = this.issuedLines.page;
                const after =Math.ceil((this.issuedLines.total)/this.issuedLines.limit);
                if (bfore != after){
                    this.issuedLines.page =  after;                 
                    toastr.info(`Move to page ${after} of total  ${this.issuedLines.total} items`,'Line/Detail',10000);
                }
        }, 100);            
    },
    editIssuedLines : function (obj,callback) {
        this.closeIssuedLines();
        obj.iteminfo = `${obj.itemno} | ${obj.itemname}`;
        obj.typeseries = obj.itemcategory;
        // obj.quantity = obj.qtyTrfOut;
        obj.unitsize = obj.invunitom;
        this.issuedLines.selected = obj;
        for (var key in this.issuedLinesObj) {
            this.issuedLinesObj[key] = '';
        }
        for (var key in obj) {
            this.issuedLinesObj[key] = obj[key];
        }
        this.dimension.forEach((dim) => {
            if (obj[dim.value]) {
                this.issuedLinesObj[dim.value] = obj[dim.value];
                this.issuedLinesObj[`${dim.value}Txt`] = obj[`${dim.value}Txt`];
                this.issuedLinesObj[`${dim.value}Info`] = obj[dim.value] + ' | '+ obj[`${dim.value}Txt`];
            }
        });
        callback();
    },
    delIssuedLines: function (index) {
        if (index > -1) {
                // this.issuedLines.items.splice(index, 1);
                const posisi = (this.issuedLines.page-1)*this.issuedLines.limit;
                this.issuedLines.items.splice(posisi+index, 1);
        }
        this.issuedLines.total=this.issuedLines.items.length;
        this.calcTotalDtlIssued();
    },
    saveIssuedLines: async function (callback) {
        this.calcAmount();
        if (this.invalidIssuedLines) {
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
       } else {
            let datadim=this.issuedLinesObj;
            datadim.TableName = 'inventory_transfer_line';
            try {
                const dimValResult = await dimension.validate(datadim);
                if (dimValResult.success) {
                    for (var key in this.issuedLinesObj) {
                        this.issuedLines.selected[key] = this.issuedLinesObj[key];
                    }
                    this.dimension.forEach((dim) => {
                        if (datadim[dim.value]) {
                            this.issuedLines.selected[dim.value] = datadim[dim.value];
                            this.issuedLines.selected[`${dim.value}Txt`] = datadim[`${dim.value}Txt`];
                        }
                    });
                    this.updateDimDtl2Hdr(datadim);
                    this.calcTotalDtlIssued();
                    this.issuedLines.selected._showDetails=false;
                    if (callback) callback();
                } else {
                    var msg = dimValResult.message;
                    if (callback) callback(new Error(msg));
                    else {
                        toastr.error(msg, "ERROR MESSAGE",10000);
                    }
                }
            } catch (error) {
                console.log('error : ', error);
                if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }
            }
        }
    },
    save: async function () {
        
        if (!this.saveEnabled) {
            toastr.error('View mode cannot be Saved');
            return;
        }
        this.saveEnabled=false;
        if (this.invalidModel) {
            console.log('validation : ', this.$v.model);
            console.log('model obj : ',this.model);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
            this.saveEnabled=true;
        } else {
            try {
                this.model.TableName = 'inventory_transfer';
                const dimValResult = await dimension.validate(this.model);
                if (dimValResult.success) {
                    // this.model.DimTableKey = diisi dari PR/SR;
                    this.model.issuedkey = this.model.issuedkey || '';
                    this.model.issuedno = this.model.issuedno || '';
                    const row = {};
                    for (var key in this.model) {
                        row[key] = this.model[key];
                    }
                    row.terms = this.model.terms;
                    row.tanggal = moment(row.tanggal).format('YYYY-MM-DD');
                    row.expectreceipt = row.expectreceipt ? moment(row.expectreceipt).format('YYYY-MM-DD') : undefined;
                    let lineno=1;
                    row.lines = this.issuedLines.items.reduce((newArr, item) => {
                        if ((item.itemno || '') != '') {
                            item.lineno = lineno;
                            item.issueValue = item.qtyTrfOut * item.invUnitCost;
                            newArr.push(item);
                            lineno += 1;
                        }
                        return newArr;
                    }, []);
                    if (row.lines.length>0) {
                        await invTrf.save(row);
                        toastr.success("Complete successfully", "Save Request");
                        this.close();
                    } else {
                        toastr.error('Please fill at least 1(one) Request Detail', 'ERROR MESSAGE');
                        this.saveEnabled=true;
                    }
                } else {
                    console.log('dimValResult : ', dimValResult);
                    var msg = dimValResult.message || 'Dimension validation error';
                    toastr.error(msg, "ERROR MESSAGE");
                    this.saveEnabled=true;
                }

            } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "Save Request Error");                
                    this.saveEnabled=true;
            }

        }
    },
    onSelectLkuItem(_selected) {
        console.log('_selected',_selected)
        this.issuedLinesObj.iteminfo = _selected.partnumber.trim() + ' | ' + _selected.itemname.trim();
        this.issuedLinesObj.description =  _selected.itemname.trim() + ' | ' + _selected.partnumber.trim();
        this.issuedLinesObj.partnumber = _selected.partnumber;
        this.issuedLinesObj.itemno = _selected.itemno;
        this.issuedLinesObj.itemname = _selected.itemname;
        this.issuedLinesObj.itemReciKey = _selected.itemReciKey;
        this.issuedLinesObj.qtyAvail = _selected.qtyAvail;
        this.issuedLinesObj.invUnitSize = _selected.invUnitSize;
        this.issuedLinesObj.invUnitCost = _selected.invUnitCost;
        this.issuedLinesObj.purcRcpHdNo = _selected.purcRcpHdNo;
        this.issuedLinesObj.serialNum = _selected.serialNum;
        this.issuedLinesObj.expirDate = _selected.expirDate ? moment(_selected.expirDate).format('YYYY-MM-DD') : '';
        this.issuedLinesObj.recivDate = _selected.recivDate ? moment(_selected.recivDate).format('YYYY-MM-DD') : '';
        
        this.lkuItemShow=false;
    },
    async onSelectLkuMr(_selected) {
        console.log('onSelectLkuMr',_selected);
        this.model.requestno=_selected.requestno;
        this.model.uraian=_selected.uraian;
        this.model.recivby=_selected.createby;
        this.model.mrsrno = _selected.requestno

        const data = await mr.detail(_selected);  
        const row = data[0][0];
        // isi Dimension Header Ap dengan Dimension Header PO ?
        this.model.DimTableKey=row.DimTableKey;
        this.updateDimDtl2Hdr(row);
        
        // untuk metode FIFO/LIFO maka detail ini hanya dipakai untuk memfilter available inventory in
        // knex select('*').from('inventory_receipt').whereIn('itemno', listItemRequested);
            const lines = data[1];
            let newLine;
            this.listItemRequested= lines.reduce((newArr, item) => {
                                            newArr.push(item.itemno);
                                                return newArr;
                                            }, []);

        // Untuk Metode AVERAGE maka detail langsung diisi ke IssuedLines
            // const lines = data[1];
            // let newLine;
            // for (let i = 0; i < lines.length; i += 1) {
            //     newLine = {};
            //     for (let key in lines[i]) {
            //         newLine[key] = lines[i][key];
            //     }
            //     newLine.lineno = i + 1;
            //     newLine.uraian_dt = lines[i].description + ' ' + (lines[i].itemname || '');
            //     newLine.glAccount = (lines[i].kodeacc) ? (lines[i].kodeacc || '').trim() + ' | ' + (lines[i].itemname || '') : '-- Please select ! -- ';

            //     this.issuedLines.push(newLine);
            // }

        this.lkuMrShow=false;
    },
    updateDimDtl2Hdr: function (dimDtl) {
        var dimHdr = this.model;
        this.dimension.forEach((dim) => {
            if ((dimDtl[dim.value]) && !(dimHdr[dim.value])) {
                dimHdr[dim.value] = dimDtl[dim.value];
                dimHdr[`${dim.value}Txt`] = dimDtl[`${dim.value}Txt`];
                dimHdr[`${dim.value}Info`] = dimDtl[`${dim.value}Info`] ;
            }
        });
        this.updateDimHdr = !this.updateDimHdr;
    },
    updateDimHdr2Dtl: function (dimDtl) {
        var dimHdr = this.model;
        dimDtl = dimDtl || this.issuedLinesObj;
        this.dimension.forEach((dim) => {
            if ((dimHdr[dim.value]) && !(dimDtl[dim.value])) {
                dimDtl[dim.value] = dimHdr[dim.value];
                dimDtl[`${dim.value}Txt`] = dimHdr[`${dim.value}Txt`];
                dimDtl[`${dim.value}Info`] = dimHdr[`${dim.value}Info`] ;
            }
        });
        this.updateDimDtl = !this.updateDimDtl;
    },
    tanggalBerubah: function(){
        this.tahun=moment(this.model.tanggal).format('YYYY');
    },
    calcAmount : function () {
        this.issuedLinesObj.nilai = parseFloat(this.issuedLinesObj.qtyTrfOut) * parseFloat(this.issuedLinesObj.invUnitCost);
        // if (this.issuedLinesObj.disc > 0) {
        //     this.issuedLinesObj.nilaidisc = this.issuedLinesObj.disc * this.issuedLinesObj.nilai / 100.0;
        // };
        // this.issuedLinesObj.nilainett = this.issuedLinesObj.nilai - parseFloat(this.model.nilaidisc || 0);
    },
    calcTotalDtlIssued: function () {
        let ttlnetto = 0;
        this.issuedLines.items.forEach( function (trx) {
            if (trx.itemno) {
                ttlnetto += (trx.nilai || 0);
            }
        });
        this.model.ttlnetto = ttlnetto;
    },

    close(){
    //   console.log('this.$store.state.prevRoute.name : ',this.$store.state.prevRoute.name);
      if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name !== 'logistic.issuedform')) {
        router.push({name:this.$store.state.prevRoute.name});
      } else {
        router.push({name:'logistic.transferout'});
        //   router.push("home");
      }
    }
  }
};
</script>
